import React, { useState, useContext } from "react";
import TradathonContext from "../../context/tradathon/TradathonContext";
import { MdContentCopy } from "react-icons/md";
import BreadCrumbs from "../../components/BreadCrumbs";
import {
  RiTwitterFill,
  RiFacebookCircleFill,
  RiWechatFill,
} from "react-icons/ri";
import {
  FaRedditAlien,
  FaDiscord,
  FaWhatsapp,
  FaFacebookMessenger,
  FaTelegramPlane,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const TradathonRoomShare = ({ location, history }) => {
  const rcode = location.search ? location.search.split("=")[1] : null;
  const [close, setClose] = useState(false);
  // const [openShare, setOpenShare] = useState(false);

  const { activeRoom } = useContext(TradathonContext);
  // const { userData } = useContext(AuthContext);

  // const handleRoomClick = () => {
  //   setOpenShare(!openShare);
  // };
  const handleClick = () => {
    navigator.clipboard.writeText(
      `http://localhost:3000/tradathon/room/join/${rcode}`
    );
    setClose(!close);
  };
  const routes = [
    { path: "/tradathon", name: "Tradathon" },

    { path: "/", name: "Share Contest" },
  ];
  return (
    <div className="TradathonRoom">
      <div className="TradathonRoomContainer">
        <BreadCrumbs routes={routes} />
        <div style={{ textAlign: "right" }}>
          <button
            className="TradathonRoom__join__button"
            style={{
              background: "rgba(69, 170, 67, 1)",
              borderRadius: "5px",
            }}
            onClick={() =>
              activeRoom
                ? history.push(
                    `/tradathon/room/result?rmid=${activeRoom._id}&rid=${activeRoom.rid}`
                  )
                : history.push("/tradathon")
            }
          >
            &nbsp;Done&nbsp;
          </button>
        </div>

        <div className="TradathonRoom__formContainer">
          {rcode && (
            <>
              <center>
                <p>Your Team is created you can Share direct Here.</p>
              </center>

              <div className="TradathonRoom__copyToClipboardContainer">
                <h3>Page Link</h3>
                <div
                  className="TradathonRoom__copyToClipboardContainer__input"
                  onClick={handleClick}
                >
                  <input
                    style={{ margin: 0 }}
                    type="text"
                    readOnly
                    value={`http://localhost:3000/tradathon/room/join/${rcode}`}
                  />
                  <button className="TradathonRoom__copyToClipboard__icon">
                    <MdContentCopy size={20} />
                  </button>
                </div>
                {close ? (
                  <div className="TradathonRoom__copyToClipboardContainer__tooltip">
                    Copied to clipboard
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="TradathonRoom__socialContainer">
                <div>
                  <Link
                    to={{
                      pathname: `https://twitter.com/intent/tweet?text=http://localhost:3000/tradathon/room/join/${rcode}`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <RiTwitterFill style={{ color: "#1DA1F2" }} size={25} />
                    </div>
                  </Link>

                  <p>Twitter</p>
                </div>
                <div>
                  <Link
                    to={{
                      pathname: `https://www.facebook.com/sharer/sharer.php?quote=http://localhost:3000/tradathon/room/join/${rcode}`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <RiFacebookCircleFill
                        style={{ color: "#2077ee" }}
                        size={25}
                      />
                    </div>
                  </Link>
                  <div></div>

                  <p>Facebook</p>
                </div>
                <div>
                  <Link
                    to={{
                      pathname: `https://www.reddit.com/submit?url=http://localhost:3000/tradathon/room/join/${rcode}`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <FaRedditAlien style={{ color: "#fe441e" }} size={25} />
                    </div>
                  </Link>

                  <p>Reddit</p>
                </div>
                <div>
                  <Link
                    to={{
                      pathname: `https://www.facebook.com/sharer/sharer.php?quote=http://localhost:3000/tradathon/room/join/${rcode}`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <FaDiscord style={{ color: "#7389d7" }} size={25} />
                    </div>
                  </Link>

                  <p>Discord</p>
                </div>
                <div>
                  <Link
                    to={{
                      pathname: `https://wa.me/?text=http://localhost:3000/tradathon/room/join/${rcode}`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <FaWhatsapp style={{ color: "#33d573" }} size={25} />
                    </div>
                  </Link>

                  <p>Whatsapp</p>
                </div>
                <div>
                  <Link
                    to={{
                      pathname: `fb-messenger://share/?link=http://localhost:3000/tradathon/room/join/${rcode}`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <FaFacebookMessenger
                        style={{ color: "#1284fb" }}
                        size={25}
                      />
                    </div>
                  </Link>

                  <p>Messenger</p>
                </div>
                <div>
                  <Link
                    to={{
                      pathname: `https://telegram.me/share/url?url=`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <FaTelegramPlane style={{ color: "#0d88c9" }} size={25} />
                    </div>
                  </Link>

                  <p>Telegram</p>
                </div>
                <div>
                  <Link
                    to={{
                      pathname: `https://telegram.me/share/url?url=http://localhost:3000/tradathon/room/join/${rcode}`,
                    }}
                    target="_blank"
                    className="TradathonRoom__socialContainer__icons"
                  >
                    <div>
                      <RiWechatFill style={{ color: "#7bb33a" }} size={25} />
                    </div>
                  </Link>
                  <p>WeChat</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TradathonRoomShare;
